module.exports = __webpack_public_path__ + "img/eat_out_06.48a13e40.jpg";